import { exportCsv } from '@/utils/csv'

// Shared by the Broker Admin and IB competition lists (SFB-1309). `rows` come from the
// admin-only export endpoints. Headers stay in English so the file is stable for analysis.
const HEADERS = [
  'Name', 'Creation Date', 'Start Date', 'End Date', 'Max Registration Date',
  'Type', 'Region/IB Name', 'Participants Registered', 'Prizes (#)', 'Prizes (USD)',
]

const COLUMNS = r => [
  r.name, r.creationDate, r.startDate, r.endDate, r.maxRegistrationDate,
  r.type, r.region, r.participantsRegistered, r.prizesCount, r.prizesUsd,
]

// Championships come as one row per stage, so they get their own file with two extra columns.
function downloadRowsCsv(fileName, rows) {
  exportCsv(fileName, HEADERS, rows.map(COLUMNS))
}

export function downloadCompetitionsCsv(rows) {
  downloadRowsCsv('competitions.csv', rows)
}

export function downloadChampionshipsCsv(rows) {
  exportCsv('championships.csv', ['Stage #', 'Stage', ...HEADERS], rows.map(r => [r.stageOrder, r.stageName, ...COLUMNS(r)]))
}
